import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async openAppointments(event) {
    event.preventDefault()
    
    // Show loading state
    const originalText = event.target.textContent
    event.target.textContent = "Loading..."
    event.target.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      const data = await response.json()

      if (data.success && data.url) {
        // Open the URL in a new tab
        window.open(data.url, '_blank')
      } else {
        console.error('Failed to get appointments session:', data.error)
        alert('Unable to open appointments dashboard. Please try again.')
      }
    } catch (error) {
      console.error('Error fetching appointments session:', error)
      alert('Network error. Please try again.')
    } finally {
      // Restore original state
      event.target.textContent = originalText
      event.target.disabled = false
    }
  }
} 